const ALLERGEN_LABELS = Object.freeze({
  egg: {
    key: "nutritionAllergenEgg-string",
    fallback: "Egg",
  },
  fish: {
    key: "nutritionAllergenFish-string",
    fallback: "Fish",
  },
  gluten: {
    key: "nutritionAllergenGluten-string",
    fallback: "Gluten",
  },
  milk: {
    key: "nutritionAllergenMilk-string",
    fallback: "Milk",
  },
  tree_nut: {
    key: "nutritionAllergenTreeNut-string",
    fallback: "Tree nut",
  },
  peanut: {
    key: "nutritionAllergenPeanut-string",
    fallback: "Peanut",
  },
  sesame: {
    key: "nutritionAllergenSesame-string",
    fallback: "Sesame",
  },
  shellfish: {
    key: "nutritionAllergenShellfish-string",
    fallback: "Shellfish",
  },
  soy: {
    key: "nutritionAllergenSoy-string",
    fallback: "Soy",
  },
});

function formatAllergenFallback(allergenCode) {
  return String(allergenCode ?? "")
    .trim()
    .toLowerCase()
    .split("_")
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");
}

export function getLocalizedAllergenLabel(allergenCode, t) {
  const normalizedCode = String(allergenCode ?? "").trim().toLowerCase();
  if (!normalizedCode) {
    return "";
  }

  const labelConfig = ALLERGEN_LABELS[normalizedCode];
  if (!labelConfig) {
    return formatAllergenFallback(normalizedCode);
  }

  if (typeof t === "function") {
    return t(labelConfig.key, labelConfig.fallback);
  }

  return labelConfig.fallback;
}

